import React, { useEffect, Fragment } from 'react';
import { Space, Button, Row, Col, Typography, Form, message, Spin } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { addUser, editUser } from '../../../../../ducks/services'
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { id, mode, errors, control, meta, data, setValue, allowedEdit, handleSubmit, reloadApi } = props;
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'username',
      label: t("System.username"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      static: !allowedEdit,
      nospace: true
    },
    {
      name: 'name',
      label: t("Outlet.name"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: true,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'email',
      label: t("System.email"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      email: true,
      twocol: true,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'roles',
      label: t("System.roles"),
      req: true,
      type: 'select',
      options: meta?.roles?.map((x) => ({ label: x.name, value: x.id })),
      placeholder: t("General.please_select"),
      twocol: false,
      multiple: true,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      let temp = [];
      data?.roles?.map(role => {
        temp.push({
          label: role.name,
          value: role.id
        })
      });
      setValue('username', data.username);
      setValue('name', data.name);
      setValue('email', data.email);
      setValue('roles', temp);
    }
  }, [data]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      ...val,
      roles: JSON.stringify(val.roles.map(x => ({id: x.value}))),
      id: id
    }

    await (mode === "add" ? addUser : editUser)(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("System.user_edit_success"));
        reloadApi(res.data.data);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };


  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}